module.exports = __webpack_public_path__ + "img/trash.6abb622c.svg";